import { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { setAuthFailureHandler } from './api/client';
import { NavigationBar } from "./components/NavigationBar";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Home } from "./components/Pages/Home";
import { Menu } from "./components/Pages/Menu";
import { About } from "./components/Pages/About";
import { Contact } from "./components/Pages/Contact";
import { Catering } from "./components/Pages/Catering";
import { Allergens } from "./components/Pages/Allergens";
import { Privacy } from "./components/Pages/Privacy";
import { AdminScheduleEdit } from "./components/Pages/Admin_edit_schedule";
import { SchedulePage } from './components/Pages/Schedule';
import { AdminHub } from './components/Pages/Admin_hub';
import { AdminMenuEdit } from "./components/Pages/Admin_edit_menu";
import { Footer } from "./components/Footer";

function AppRoutes() {
  const { clearAuth } = useAuth();

  useEffect(() => {
    setAuthFailureHandler(clearAuth);
  }, [clearAuth]);

  return (
    <div className="App">
      <NavigationBar />
      <main className="app-content">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/about" element={<About />} />
          <Route path="/catering" element={<Catering />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/allergens" element={<Allergens />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* Protected admin routes */}
          <Route path="/admin" element={<ProtectedRoute><AdminHub /></ProtectedRoute>} />
          <Route path="/admin/schedule" element={<ProtectedRoute><AdminScheduleEdit /></ProtectedRoute>} />
          <Route path="/admin/menu" element={<ProtectedRoute><AdminMenuEdit /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
